import * as React from 'react';

function IconActionTrashLarge(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" {...props}>
      <path
        d="M21 10V9C21 7.67392 20.4732 6.40215 19.5355 5.46447C18.5979 4.52678 17.3261 4 16 4C14.6739 4 13.4021 4.52678 12.4645 5.46447C11.5268 6.40215 11 7.67392 11 9V10H6V12H26V10H21ZM13 9C13 8.20435 13.3161 7.44129 13.8787 6.87868C14.4413 6.31607 15.2044 6 16 6C16.7956 6 17.5587 6.31607 18.1213 6.87868C18.6839 7.44129 19 8.20435 19 9V10H13V9Z"
        fill="currentColor"
      />
      <path d="M10 28H22L24 14H8L10 28Z" fill="currentColor" />
    </svg>
  );
}

export default IconActionTrashLarge;
